import { jsx as _jsx } from "react/jsx-runtime";
import _slicedToArray from "/home/app/node_modules/next/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import * as channel from '../../config/constants/channel';
import { useChannelMutation } from '../../hooks/use-channel-mutation';
import { emailValidation } from '../../masks-and-validators/email-validation';
import { useAppMode } from '../../hooks/use-app-mode';
import ChannelConfirmationContainer from './channel-confirmation-container';
import { useChannelSelection } from '../../hooks/use-channel-selection';
import { useUserInfo } from '../../hooks/use-user-info';
import { MailIcon, InputText } from '@aftersale-next/ui';
export default function EmailConfirmation() {
  var customerEmail = useUserInfo('email');

  var _useState = useState(''),
      email = _useState[0],
      setEmail = _useState[1];

  var _useState2 = useState(false),
      error = _useState2[0],
      setError = _useState2[1];

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var _useAppMode = useAppMode(),
      _useAppMode2 = _slicedToArray(_useAppMode, 2),
      setMode = _useAppMode2[1];

  var _useChannelSelection = useChannelSelection(),
      _useChannelSelection2 = _slicedToArray(_useChannelSelection, 2),
      setSelected = _useChannelSelection2[1];

  var mutation = useChannelMutation({
    onSuccess: function onSuccess() {
      setMode('tracking');
      setSelected('');
    }
  });

  var handleConfirm = function handleConfirm() {
    mutation.mutate({
      channel: channel.EMAIL,
      data: {
        email: email
      }
    });
  };

  var handleChange = function handleChange(email) {
    setEmail(email);
    emailValidation.validate(email).then(function (value) {
      return setError(false);
    })["catch"](function (err) {
      return setError(true);
    });
  };

  useEffect(function () {
    setEmail(customerEmail);
  }, [customerEmail]);
  return /*#__PURE__*/_jsx(ChannelConfirmationContainer, {
    name: "email",
    isDisabled: mutation.isLoading || error,
    isLoading: mutation.isLoading,
    handleConfirm: handleConfirm,
    label: t('EMAIL'),
    icon: /*#__PURE__*/_jsx(MailIcon, {}),
    children: /*#__PURE__*/_jsx(InputText, {
      id: "email-input",
      name: "email-input",
      label: t('YOUR_EMAIL'),
      placeholder: t('EMAIL_PLACEHOLDER'),
      value: email,
      onChange: handleChange,
      error: error
    })
  });
}